import Card from "../Card";

const Commodore = () => (
  <Card
    image="/images/fleet/commodore/Cedar_Hill_Angl1-2.jpg"
    title="Commodore"
    titleLink="/fleet/commodore"
    subtitle="Adventure-Ready Landship"
    description="A comfortable, self-contained Ford E-350 Landship built for real travel and adventures. Adventure road trips, sightseeing, and multi-stop travel across Texas and beyond."
    ctaText="Rent Commodore"
    ctaLink="/fleet/commodore"
    variant="image-left"
  />
);

export default Commodore;
